<template>

  <div class="upload-wrapper">
    <el-upload ref="uploadlist" :action="url" :data="formData" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :file-list="defaultList" :show-file-list="true" :limit="10" :on-exceed="handleExceed" :on-error="handleError" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
      <i class="el-icon-plus"></i>
    </el-upload>
    <viewer :images="uploadList" class="viewer" ref="viewer" @inited="inited">
      <img v-for="(item,index) in uploadList" :src="item.url" :key="index" class="image">
    </viewer>
  </div>
</template>
<script>
import { field } from "@/assets/js/consts";
export default {
  data () {
    return {
      isShow: false, //是否显示
      defaultList: [],
      imgName: "",
      uploadList: [],
      url: "", //上传地址
      formData: {}, //额外参数,
      isError: false
    };
  },
  props: {
    img_list: {
      //图片列表
      required: true,
      type: Array
    },
    img_dir: {
      //图片存储文件夹
      required: false,
      type: String,
      default: ""
    }
  },
  mounted () {
    this.defaultList = []
    this.uploadList = []
    this.url = field.domain + "/upload.do";
    let token = this.utils.getToken();
    this.formData = {
      token: token.replace('"', "").replace('"', ""),
      path: "images/" + this.img_dir,
      active: field.env
    };
    let arr = [];
    this.img_list.forEach((item) => {
      arr.push(this.covertData(item));
    });
    this.defaultList = arr;
    this.$nextTick(() => {
      this.uploadList = this.$refs.uploadlist.uploadFiles;
      // 这样打印出来就会有值
    });
  },
  methods: {
    //预览
    inited (viewer) {
      this.$viewer = viewer;
    },
    handlePreview (url) {
      this.$refs.viewer.updateViewer();
      let index = this.uploadList.findIndex((sub) => {
        return sub.url == url;
      });
      console.log(index, this.uploadList)
      this.$viewer.view(index);
    },
    //转换数据
    covertData (item) {
      let temObj = {
        name: "img",
        url: item,
      };
      return temObj;
    },
    handleRemove (file, fileList) {
      this.$emit("call", fileList);
    },
    handlePictureCardPreview (file) {
      this.handlePreview(file.url)

    },
    handleAvatarSuccess (response, file, fileList) {
      if (response.code == "500") {
        this.$notify.error({
          title: "上传失败，上传图片接口异常",
          message: "接口编号：(upload.do)"
        });
        fileList = [];
        return;
      }
      this.$message({
        message: "图片上传成功",
        type: "success"
      });
      this.$emit("call", fileList);
    },
    handleExceed (files, fileList) {
      this.$notify.error({
        title: "图片数量超出",
        message: "最多只能上传10张照片"
      });
    },
    handleError (error) {
      console.log(error);
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt15M = file.size / 1024 / 1024 < 15;

      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        this.isError = true;
      }
      if (!isLt15M) {
        this.$message.error('文件不能超过 15MB!');
      }

      return (isJPG || isPNG) && isLt15M;
    }
  }
};
</script>
<style scoped lang="scss">
/deep/ .el-upload-list--picture-card .el-upload-list__item-actions span + span {
  margin-left: 80px;
}
.upload-wrapper {
  display: flex;
  align-items: center;
  // flex-wrap: wrap;
  .el-upload--picture-card {
    width: 120px;
    height: 120px;
    display: inline-block;
  }
}
.upload-ft .viewer {
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.el-upload {
  width: 100%;
  height: 120px;
  display: inline-block;
}
.upload-list {
  display: inline-block;
  width: 120px;
  height: 120px;
  text-align: center;
  line-height: 120px;
  border: 1px solid #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  margin-right: 20px;
  padding: 5px;
}
.upload-list img {
  width: 100%;
  height: 100%;
}
.upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
}
.upload-list:hover .upload-list-cover {
  display: block;
}
.upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
.upload-text {
  margin-top: 10px;
}
.el-icon-plus {
  color: #ccc;
  font-size: 30px;
}
.el-upload-dragger {
  width: 120px;
  height: 120px;
  display: inline-block;
}
.xx-btn-group {
  padding-top: 100px;
}
.viewer {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-list.vue